import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import randomstring from 'uuid/v4';
import SettingsApplications from '@material-ui/icons/SettingsApplications';

import * as actions from '../../../actions/xhef.actions';
import Snackbar from '../../labels/Snackbar';

import ForecastWidget from './ForecastWidget';
import MachineChangeType from './MachineEditPopup';

// eslint-disable-next-line
import style from './_styles.css';

class Machines extends Component {
    state = {
        selected: undefined
    };

    static getDerivedStateFromProps(props, state) {
        const { data } = props;
        if (data !== state.data) {
            state.data = data;
            return state;
        }
        return null;
    }

    handleChangeMachine = (item) => {
        if (!item.nomProducto) {
            this.setState({ selected: item })
        }
    }

    handleCloseChangeMachine = (id, name) => {
        if (id) {
            this.props.changeMachine(this.state.selected.id, name, id);
        }
        this.setState({ selected: undefined });
    }

    render() {
        const { data, error, selected } = this.state;
        const { info } = this.props;
        const edit = info &&
            info.security &&
            info.security.totalPermits &&
            info.security.totalPermits.some((p) =>
                [20, 59, 67].some((s) => s.toString() === p.toString()),
            );
        const Item = (item) => {
            return (
                <div
                    key={randomstring()}
                    className="flex_full_column boxShadow margin_bottom_12"
                >
                    <div className="flex_full_row bg_slate c_white padding_borders_equals align_center">
                        <span
                            onClick={() => this.props.handleOpenMachine('machine', item)}
                            className="flex_auto_row barlow_semibold_label c_cool_grey align_center hand">
                            {item.estado === 4 && (
                                <Fragment>
                                    <div className="circleStatus bg_golden_yellow margin_right_6" />
                                    <FormattedMessage id="xhef_machine_status_busy" />
                                </Fragment>
                            )}
                            {item.estado === 3 && (
                                <Fragment>
                                    <div className="circleStatus bg_pea margin_right_6" />
                                    <FormattedMessage id="xhef_machine_status_available" />
                                </Fragment>
                            )}
                            {item.estado === 2 && (
                                <Fragment>
                                    <div className="circleStatus bg_lipstickligth margin_right_6" />
                                    <FormattedMessage id="xhef_machine_status_paused" />
                                </Fragment>
                            )}
                            {item.estado === 1 && (
                                <Fragment>
                                    <div className="circleStatus bg_lipstick margin_right_6" />
                                    <FormattedMessage id="xhef_machine_status_disabled" />
                                </Fragment>
                            )}
                        </span>
                        <span className="flex_full_row barlowsemicondensed_title c_white padding_left_6 ">
                            {item.nTipomaquina}
                        </span>
                        {(!!edit && !item.nomProducto) &&
                            <SettingsApplications className={"c_state hand"} onClick={() => this.handleChangeMachine(item)} />
                        }
                    </div>
                    <div
                        onClick={() => this.props.handleOpenMachine('machine', item)}
                        className="flex_full_row c_slate bg_white center padding_bottom_6  padding_top_6 padding_right_6 padding_left_6 hand">
                        <span className="flex_full_row barlow_medium_place_holder c_dark_grey_blue nowrap padding_right_6">
                            {item.nombre}
                        </span>
                        <span className="flex_full_row barlow_italic_small c_purple uppercase padding_left_6">
                            {item.nomProducto}
                        </span>
                    </div>
                </div>
            );
        };

        return (
            <div className="flex_full_column">
                <ForecastWidget {...this.props} />
                {selected &&
                    <MachineChangeType {...this.props} machine={selected} handleClose={this.handleCloseChangeMachine} />
                }
                <div id="xhef" className="flex_full_column boxShadow bg_white">
                    <div className="flex_auto_row barlow_semibold c_dark_grey_blue padding_top_6 padding_bottom_12 padding_left_6 padding_right_6">
                        <FormattedMessage id="xhef_machines" />
                    </div>
                    <div className="flex_full_column padding_top_6 padding_bottom_12 padding_left_6 padding_right_6 overflow_y_scroll">
                        {data.map((d) => {
                            return <Item key={randomstring()} {...d} />;
                        })}
                        {this.props.xef_reference_time.replace('T', ' ').substr(0, 19)}
                    </div>
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            nonavbar={true}
                            onClose={this.handleClose}
                        />
                    )}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        info: state.info,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Machines));



// WEBPACK FOOTER //
// ./src/components/complex/xhef/Machines.js